import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chart",
  "use": "icon-chart-usage",
  "viewBox": "0 0 44 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44 48\" id=\"icon-chart\">\r\n  <path id=\"icon-chart_char\" d=\"M13,48H1V36H13ZM29,30H17V48H29Zm16-8H33V48H45ZM45,0,33,2.442l3.432,3.416-13.7,13.466-6-6L1.048,28.914l2.82,2.836L16.722,18.97,22.7,24.956,39.264,8.682,42.6,12,45,0Z\" transform=\"translate(-1)\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol